module.exports = __webpack_public_path__ + "img/li5.42378b16.jpg";